import styled from 'styled-components';

import { P } from '../typography';

/* ----------------------------- ModalBackground ---------------------------- */

export const ModalBackground = styled.div`
    align-items: center;
    background: rgba(0, 0, 0, 0.8);
    bottom: 0;
    display: flex;
    justify-content: center;
    left: 0;
    position: fixed;
    right: 0;
    top: 0;
    z-index: 1000;

    /*
        Checks for support of a specific CSS feature before implementing
        https://caniuse.com/mdn-css_at-rules_supports_selector

        In this case we use it as we want a different background opacity if we have access to blur
    */
    @supports (
        (backdrop-filter: blur(5px)) or (-webkit-backdrop-filter: blur(5px))
    ) {
        -webkit-backdrop-filter: blur(5px);
        backdrop-filter: blur(5px);
        background: rgba(0, 0, 0, 0.2);
    }
`;

/* ----------------------------- ModalContainer ----------------------------- */

export const ModalContainer = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: center;
`;

/* ------------------------------- StyledModal ------------------------------ */

export const StyledModal = styled.div(
    ({ theme }) => `
        margin: 1rem;
        padding: 2rem;
        background: ${theme.sections.page.background};
        color: ${theme.sections.page.a};
        max-width: 40ch;
        border-radius: 0.5rem;
        box-shadow: 0px 0px 11px 1px rgba(0,0,0,0.7);

        span {
            display: block;
            font-size: 0.8rem;
            line-height: 150%;
        }

        ${P} {
            line-height: 150%;
        }

        a[href] {
            color: ${theme.sections.page.feature};

            &:hover {
                text-decoration: none;
            }
        }
    `,
);

/* ---------------------------- ModelButtonGroup ---------------------------- */

export const ModalButtonGroup = styled.div(
    ({ theme }) => `
        display: flex;
        flex-direction: column;
        gap: 1rem;
        margin: 1rem 0 1.5rem 0;

        button {
            appearance: none;
            border: none;
            padding: 0.6rem 0.75rem;
            text-align: left;
            background: ${theme.sections.page.feature};
            color: ${theme.sections.page.featureText};

            border-radius: 0.275rem;
            font-size: 1rem;
            cursor: pointer;
            transition: all 0.33s;

            i {
                margin-right: 0.275rem;
            }

            :hover {
                background: ${theme.sections.page.featureMouseover};
                color: ${theme.sections.page.featureMouseoverText};
            }
        }
    `,
);
